module.exports = __webpack_public_path__ + "assets/default-alt.b4b15332.svg";